<mat-card style="padding: 0.5in;">
	<mat-card-header style="border-bottom: 1px solid black;">

		<div class="row " style="margin-bottom: 20px; width:100%;">
			<div class="col-sm-6" style="text-align: left;">
				<button mat-raised-button (click)="closeDialog()">
					<mat-icon>close</mat-icon>
					Close
				</button>
			</div>
			<div class="col-sm-6" style="text-align: right;">
				<button mat-raised-button color="primary" (click)="printReport()">
					<mat-icon>print</mat-icon>
					Print Report
				</button>
			</div>
		</div>
	</mat-card-header>
	<mat-card-content style="overflow: auto; max-height: 80vh;">

		<!-- Display Header (visible on screen, not in PDF) -->
		<div class="screen-only-header" style="padding: 0.25in; background-color: white; width: 8.5in; box-sizing: border-box;">
			<div class="row" style="box-sizing: border-box;">
				<div class="col-sm-2">
					<img src="assets/images//ORELAP.jpg" alt="Orelap Oregon Health Authority Seal" style="height: 100px;" />
				</div>
				<div class="col-sm-8" style="padding-top: 0.25in;align-content: center;">
					<div class="row">
						<div class="col-sm-12" style="text-align:center">
							<span style="font-size:24px">
								<strong>Oregon</strong>
							</span>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12" style="text-align:center">
							<span style="font-size:18px">
								<strong>Environmental Laboratory Accreditation Program</strong>
							</span>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12" style="text-align:center">
							<span style="font-size:18px">
								<strong>ORELAP Fields of Accreditation</strong>
							</span>
						</div>
					</div>
				</div>
				<div class="col-sm-2">
					<img src="assets/images/nelap2.jpg" alt="Nelap Recognized" style="width: 100%; height: auto;" />
				</div>
			</div>

			<div class="row" style="margin-top: 20px;">
				<div class="col-sm-8">
					<div class="row">
						<div class="col-sm-12">
							<span style="font-size:16px; text-decoration: underline;">
								{{attachedData?.labName}}
							</span>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
							<span style="font-size:16px">{{encodeForPdf(attachedData?.siteAddress)}}</span>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
							<span style="font-size:16px">
								{{attachedData?.siteCity}}, {{attachedData?.siteState}} {{attachedData?.siteZip}}</span>
						</div>
					</div>
				</div>
				<div class="col-sm-4">
					<div class="row">
						<div class="col-sm-6">
							<span class="pull-right" style="font-size:16px"><strong>ORELAP ID: </strong></span>
						</div>
						<div class="col-sm-6">
							<span>{{attachedData?.orelapId}}</span>
						</div>
					</div>

					<div class="row">
						<div class="col-sm-6">
							<span class="pull-right" style="font-size:16px"><strong>EPA CODE: </strong></span>
						</div>
						<div class="col-sm-6">
							<span style="font-size:16px">{{attachedData?.epaId}}</span>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
							<span class="pull-right" style="font-size:16px"><strong>Certificate: </strong></span>
						</div>
						<div class="col-sm-6">
							<span>{{attachedData?.certificateNumber}}</span>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
							<span class="pull-right" style="font-size:10px">Issue Date: {{attachedData?.issueDate}} &nbsp;
								Expiration Date: {{attachedData?.expirationDate}}</span>
						</div>
					</div>
				</div>
			</div>

			<div class="row" style="margin-top: 15px;">
				<div class="col-sm-12">
					<span style="font-size:12px"><strong>As of {{attachedData?.issueDate}} this list supersedes all previous
							lists for this certificate number.</strong></span>
				</div>
			</div>

			<div class="row">
				<div class="col-sm-12">
					<table class="table table-condensed">
						<colgroup>
							<col style="width: 8%" />
							<col style="width: 10%" />
							<col style="width: 10%" />
							<col style="width: 20%" />
							<col style="width: 10%" />
							<col style="width: 10%" />
							<col style="width: 10%" />
							<col style="width: 22%" />
						</colgroup>
						<thead>
							<tr style="border-bottom:solid">
								<th style="font-size:medium">Matrix</th>
								<th style="font-size:medium">Reference</th>
								<th style="font-size:medium">Analyte Code</th>
								<th style="font-size:medium">Analyte</th>
								<th style="font-size:medium">Revision</th>
								<th style="font-size:medium">Rev. Date</th>
								<th style="font-size:medium">Method Code</th>
								<th style="font-size:medium">Description</th>
							</tr>
						</thead>
					</table>
				</div>
			</div>
		</div>

		<kendo-pdf-export #pdf paperSize="letter" [scale]="0.75" forcePageBreak=".page-break"
			[margin]="{ top: '2.53in', right: '0in', bottom: '1.25in', left: '0in' }">		
		<!-- <kendo-pdf-export #pdf paperSize="letter" [scale]="0.75"
			[margin]="{ top: '0in', right: '0in', bottom: '2.75in', left: '0in' }"> -->
			<ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
				<!-- PDF Report Header -->
				<div class="page-template"
					style="padding-left: 0.25in; padding-right: 0.25in; position: absolute; top: 0; width: 100%;">
					<div class="row" style="box-sizing: border-box;">
						<div class="col-sm-2">
							<img src="assets/images//ORELAP.jpg" alt="Orelap Oregon Health Authority Seal" style="height: 100px;" />
						</div>
						<div class="col-sm-8" style="padding-top: 0.25in;align-content: center;">
							<div class="row">
								<div class="col-sm-12" style="text-align:center">
									<span style="font-size:24px">
										<strong>Oregon</strong>
									</span>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12" style="text-align:center">
									<span style="font-size:18px">
										<strong>Environmental Laboratory Accreditation Program</strong>
									</span>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12" style="text-align:center">
									<span style="font-size:18px">
										<strong>ORELAP Fields of Accreditation</strong>
									</span>
								</div>
							</div>
						</div>
						<div class="col-sm-2">
							<img src="assets/images/nelap2.jpg" alt="Nelap Recognized" style="width: 100%; height: auto;" />
						</div>
						<div class="col-sm-1"></div>
					</div>

					<div class="row">
						<div class="col-sm-8">
							<div class="row">
								<div class="col-sm-12">
									<span style="font-size:16px; text-decoration: underline;">
										{{attachedData?.labName}}
									</span>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12">
									<span style="font-size:16px">{{attachedData?.siteAddress}}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12">
									<span style="font-size:16px">
										{{attachedData?.siteCity}}, {{attachedData?.siteState}} {{attachedData?.siteZip}}</span>
								</div>
							</div>
						</div>
						<div class="col-sm-4">
							<div class="row">
								<div class="col-sm-6">
									<span class="pull-right" style="font-size:16px"><strong>ORELAP ID: </strong></span>
								</div>
								<div class="col-sm-6">
									<span>{{attachedData?.orelapId}}</span>
								</div>
							</div>

							<div class="row">
								<div class="col-sm-6">
									<span class="pull-right" style="font-size:16px"><strong>EPA CODE: </strong></span>
								</div>
								<div class="col-sm-6">
									<span style="font-size:16px">{{attachedData?.epaId}}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-6">
									<span class="pull-right" style="font-size:16px"><strong>Certificate: </strong></span>
								</div>
								<div class="col-sm-6">
									<span>{{attachedData?.certificateNumber}}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12">
									<span class="pull-right" style="font-size:10px">Issue Date: {{attachedData?.issueDate}} &nbsp;
										Expiration Date: {{attachedData?.expirationDate}}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
							<span style="font-size:12px"><strong>As of {{attachedData?.issueDate}} this list supersedes all previous
									lists for this certificate number.</strong></span>
						</div>
					</div>
					<br />
					<div class="row">
						<div class="col-sm-12">
							<table class="table table-condensed">
								<colgroup>
									<col style="width: 8%" />
									<col style="width: 10%" />
									<col style="width: 10%" />
									<col style="width: 20%" />
									<col style="width: 10%" />
									<col style="width: 10%" />
									<col style="width: 10%" />
									<col style="width: 22%" />
								</colgroup>
								<thead>
									<tr style="border-bottom:solid">
										<th style="font-size:medium">Matrix</th>
										<th style="font-size:medium">Reference</th>
										<th style="font-size:medium">Analyte Code</th>
										<th style="font-size:medium">Analyte</th>
										<th style="font-size:medium">Revision</th>
										<th style="font-size:medium">Rev. Date</th>
										<th style="font-size:medium">Method Code</th>
										<th style="font-size:medium">Description</th>
									</tr>
								</thead>
							</table>
						</div>
					</div>
				</div>

				<!-- PDF Report Footer -->
				<div class="page-template"
					style="padding-left: 0.25in;padding-right: 0.25in;padding-bottom: 0.25in;position: absolute; bottom: 0; width: 100%; font-size: 10px;">
					<div style="border-top: 1px solid black;">
						<div class="row">
							<div class="col-sm-12">
								Department of Agriculture, Laboratory Division
							</div>
						</div>
						<div class="row">
							<div class="col-sm-12">
								Department of Environmental Quality, Laboratory Division
							</div>
						</div>
						<div class="row">
							<div class="col-sm-12">
								Oregon Health Authority, Public Health Division
							</div>
						</div>
					</div>
					<div style="text-align: right;">
						Printed {{datePrinted}} - Page {{pageNum}} of {{totalPages}}
					</div>
				</div>
			</ng-template>

			<!-- <div class="report-content"
				style="padding: 0.25in;background-image: url('assets/images/TNI.png'); background-repeat: no-repeat; background-position: top; width: 8.5in; box-sizing: border-box;"> -->
			<div class="report-content"
				style="padding: 0.25in;background-image: url('assets/images/TNI.png'); background-repeat: no-repeat; background-position: top;">

				<div class="row">
					<div class="col-sm-12">
						<table class="table table-condensed" style="page-break-inside: inherit;">
							<colgroup>
								<col style="width: 8%" />
								<col style="width: 10%" />
								<col style="width: 10%" />
								<col style="width: 20%" />
								<col style="width: 10%" />
								<col style="width: 10%" />
								<col style="width: 10%" />
								<col style="width: 22%" />
							</colgroup>
							<tbody>

								<ng-container *ngFor="let matrix of attachedList">
									<tr>
										<td style="border-top:solid" colspan="8">
											<span style="font-size:medium">
												<strong>
													{{matrix.matrix}}
												</strong>
											</span>
										</td>
									</tr>
									<ng-container *ngFor="let foa of matrix.foaList">
										<tr>
											<td></td>
											<td style="border-top: 1px solid black; vertical-align: top;">
												{{foa.foas[0].methodReference}}
											</td>
											<td style="border-top: 1px solid black;"></td>
											<td style="border-top: 1px solid black;"></td>
											<td style="border-top: 1px solid black; vertical-align: top; text-align: center;">
												{{foa.foas[0].revision}}
											</td>
											<td style="border-top: 1px solid black; vertical-align: top; text-align: center;">
												{{foa.foas[0].date}}
											</td>
											<td style="border-top: 1px solid black; vertical-align: top;">
												{{foa.foas[0].methodCode}}
											</td>
											<td style="border-top: 1px solid black; vertical-align: top;">
												{{foa.foas[0].methodTitle}}
											</td>
										</tr>
										<tr *ngFor="let analyte of foa.foas">
											<td style="border-top:none"></td>
											<td style="border-top:none"></td>
											<td style="border-top:none; text-align: center;vertical-align: top;">
												{{analyte.analyteCode}}
											</td>
											<td style="border-top:none;">
												{{analyte.analyte}}
											</td>
											<td style="border-top:none"></td>
											<td style="border-top:none"></td>
											<td style="border-top:none"></td>
											<td style="border-top:none"></td>
										</tr>
									</ng-container>
								</ng-container>
							</tbody>
						</table>
					</div>
				</div>

			</div>
		</kendo-pdf-export>

	</mat-card-content>
</mat-card>